/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExperienceResource } from './';
import {
    ExperienceResourceFromJSON,
    ExperienceResourceFromJSONTyped,
    ExperienceResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ResumePreviewResource
 */
export interface ResumePreviewResource {
    /**
     * 
     * @type {Array<ExperienceResource>}
     * @memberof ResumePreviewResource
     */
    experiences: Array<ExperienceResource>;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof ResumePreviewResource
     */
    duplicatedExperienceIds?: Array<Array<string>>;
}

/**
 * Check if a given object implements the ResumePreviewResource interface.
 */
export function instanceOfResumePreviewResource(value: object): value is ResumePreviewResource {
    if (!('experiences' in value) || value['experiences'] === undefined) return false;
    return true;
}

export function ResumePreviewResourceFromJSON(json: any): ResumePreviewResource {
    return ResumePreviewResourceFromJSONTyped(json, false);
}

export function ResumePreviewResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResumePreviewResource {
    if (json == null) {
        return json;
    }
    return {
        
        'experiences': ((json['experiences'] as Array<any>).map(ExperienceResourceFromJSON)),
        'duplicatedExperienceIds': json['duplicatedExperienceIds'] == null ? undefined : json['duplicatedExperienceIds'],
    };
}

export function ResumePreviewResourceToJSON(value?: ResumePreviewResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'experiences': ((value['experiences'] as Array<any>).map((v) => ExperienceResourceToJSON(v))),
        'duplicatedExperienceIds': value['duplicatedExperienceIds'],
    };
}

